import { jsx as _jsx } from "react/jsx-runtime";
export default function Vault() {
    return /*#__PURE__*/ _jsx("div", {
        className: "p-8",
        children: /*#__PURE__*/ _jsx("div", {
            className: "max-w-7xl mx-auto"
        })
    });
}
